import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setHours(24, 0, 0, 0);
      const diff = tomorrow.getTime() - now.getTime();
      return {
        hours: Math.floor(diff / (1000 * 60 * 60) % 24),
        minutes: Math.floor(diff / 1000 / 60 % 60),
        seconds: Math.floor(diff / 1000 % 60)
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="bg-brand-green text-white font-bold py-2 px-4 sticky top-0 z-50 flex justify-center items-center gap-2 shadow-md" data-id="element-54">
      <Clock className="w-5 h-5 animate-pulse" data-id="element-55" />
      <span className="uppercase tracking-wide text-sm md:text-base" data-id="element-56">
        La oferta termina en:
      </span>
      <div className="flex items-center gap-1 font-mono text-lg md:text-xl bg-white text-brand-green px-2 py-0.5 rounded" data-id="element-57">
        <span data-id="element-58">{formatTime(timeLeft.hours)}</span>
        <span className="text-brand-green animate-pulse" data-id="element-59">:</span>
        <span data-id="element-60">{formatTime(timeLeft.minutes)}</span>
        <span className="text-brand-green animate-pulse" data-id="element-61">:</span>
        <span data-id="element-62">{formatTime(timeLeft.seconds)}</span>
      </div>
    </div>;
}